export const LOAD_ROLE_REQUEST = "LOAD_ROLE_REQUEST";
export const LOAD_ROLE_SUCCESS = "LOAD_ROLE_SUCCESS";
export const LOAD_ROLE_FAIL = "LOAD_ROLE_FAIL";

export const ALL_ROLE_REQUEST = "ALL_ROLE_REQUEST";
export const ALL_ROLE_SUCCESS = "ALL_ROLE_SUCCESS";
export const ALL_ROLE_FAIL = "ALL_ROLE_FAIL";
